export const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

export function onlyDigits(value: string) {
  return value.replace(/\D+/g, '')
}

export function maskCpf(cpfDigits: string) {
  const d = onlyDigits(cpfDigits).padStart(11, '0').slice(-11)
  return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export function maskCnpj(cnpjDigits: string) {
  const d = onlyDigits(cnpjDigits).padStart(14, '0').slice(-14)
  return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export function parsePtBrCurrencyToNumber(value: string): number {
  // "1.234,56" -> 1234.56
  const normalized = value.replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')
  const n = Number(normalized)
  return Number.isFinite(n) ? n : 0
}

export function formatDateBr(date: Date) {
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yyyy = String(date.getFullYear())
  return `${dd}/${mm}/${yyyy}`
}

